import React, { useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useDispatch, useSelector } from 'react-redux'
import { Button, CircularProgress } from '@material-ui/core'
import { SearchWidget } from 'pages/HomePage/components'
import { Footer, HeaderBox, MainLayout, NavBar, PageContainer } from 'shared'
import { EventCard } from 'shared/EventCard'
import { loadUpcomingForMeAll, resetUpcomingForMeAll } from 'state/modules/events'

import { useStyles } from './MyUpcomingEventsPage.style'

const MyUpcomingEventsPage = () => {
  const classes = useStyles()
  const { user } = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const { upcomingEventsAll, upcomingAllLastPage, upcomingEventsAllPending } = useSelector(
    (state) => state.events
  )

  const [page, setPage] = useState(1)

  useEffect(() => {
    if (user) dispatch(loadUpcomingForMeAll(page))
  }, [dispatch, page, user])

  useEffect(() => {
    return () => {
      dispatch(resetUpcomingForMeAll())
    }
  }, [dispatch])

  return (
    <MainLayout>
      <NavBar widget={(props) => <SearchWidget mini {...props} />} showWidget />
      <PageContainer>
        <div className={classes.mainContainer}>
          <HeaderBox titles={['Mis eventos', 'Próximos eventos']} />
          <div className={classes.bodyContainer}>
            {!!upcomingEventsAll.length && (
              <InfiniteScroll
                dataLength={upcomingEventsAll.length}
                next={() => {
                  if (user) {
                    setPage((state) => state + 1)
                  }
                }}
                hasMore={!upcomingAllLastPage}
                className={classes.eventsContainer}>
                {upcomingEventsAll.map((event) => (
                  <div className={classes.cardContainer} key={event.id}>
                    <EventCard event={event} />
                  </div>
                ))}
              </InfiniteScroll>
            )}
            {upcomingEventsAllPending && (
              <div className={classes.containerLoader}>
                <CircularProgress size={40} color='secondary' />
              </div>
            )}
            <div className={classes.endContainer}>
              {!upcomingEventsAllPending && !upcomingEventsAll.length && (
                <p>No hay eventos próximos</p>
              )}
              <div className={classes.buttonsContainer}>
                {!upcomingEventsAllPending && !upcomingAllLastPage && (
                  <div className={classes.buttonContainer}>
                    <Button
                      color='primary'
                      variant='contained'
                      className={classes.button}
                      onClick={() => {
                        setPage((state) => state + 1)
                      }}>
                      Ver más
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </PageContainer>
      <Footer />
    </MainLayout>
  )
}

export default MyUpcomingEventsPage
